import Layout from '../../../layout/Layout'
import Breadcrumb from 'components/atoms/Breadcrumb/Breadcrumb'
import arrowIcon from '../../../assets/arrowNext.png'
import { useParams } from 'react-router-dom'
import PatternEdit from 'components/organisms/PatternEdit/PatternEdit'

export default function EditTemplatePage() {
    const { patternId } = useParams()
    const patternIdNumber = Number(patternId)
    const breadcrumbNavigate = [
        {
            label: 'Plantillas',
            path: '/templates',
        },
        {
            label: 'Editar Plantilla',
            path: '/templates/edit/:id',
        },
    ]

    return (
        <Layout>
            <div className='flex justify-between px-6 mt-10 items-end'>
                <div>
                    <Breadcrumb
                        items={breadcrumbNavigate}
                        separator={<img src={arrowIcon} alt="arrowIcon" />}
                        title="Editar plantilla"
                    />
                </div>
            </div>
            <PatternEdit patternId={patternIdNumber} />
        </Layout>
    )
}